<template>
    <div class="videoHome">
        <div class="videoBox">
            <div class="videoTitle">
                <div class="viderName">视频预览</div>
                <div class="closeVideo" @click="closePlayer">
                    <img src="/static/images/closeIcon.png" alt="">
                </div>
            </div>
            <div class="videoPlayer" id="videoPlayer"></div>
        </div>
    </div>

</template>
<script>
import bus from '../../assets/eventBus/enentBus.js'
import api from '../../utils/api.js';
export default {
    name:'videoPlayer',
    data(){
        return{
            height:null,
            videoId:null,
            videoName:null,
            videoSourse:null,
            sectionId:null,
            id:null,
            videoObject: {
                vid: '',
                siteid: '3BF7C9738A6F67BC',
                mediatype: 1,
                autoStar: false,
                width: "100%",
                height: "100%",
                isShare: 'true',
                parentNode: '#videoPlayer'
            }
        }
    },
    created(){
        const that = this;
        this.height = document.documentElement.clientHeight - 80 +'px';
        bus.$off('videoId')
        bus.$on('videoId',function(msg){
            that.videoId = msg.videoId;
            that.videoName = msg.name;
            that.videoSourse = msg.sourse;
            that.id = msg.id;
            that.sectionId = msg.packageSectionId;
            console.log('播放器',msg)
            that.createPlayer(msg.videoId);
        })
        this.setPlayerCallBack();
    },
    mounted(){

    },
    methods:{
        closePlayer(){
            let userType = localStorage.getItem('userType');
            this.$emit('closePlayer',false)
            var url = '';
            const time = window.cc_js_Player.getPosition();
            const params = {
                  resourceId:this.id,
                  resourceName: this.videoName,
                  resourceSource:this.videoSourse,
                  operateAccess:3,
                  userId:localStorage.getItem('userId'),
                  operateDuration:time
              }
            if (userType == 'teacher') {
              url = '/axt-statistics/statistics_teacher/addRecord';
              params.resourceType = 1;
              params.operateTypeId = 10;
            }else {
              url =  '/axt-statistics/statistics_student/addRecord';
              params.operateTypeId = 11;
            }
            if(this.videoSourse == 0){
              if (userType == 'teacher') {
                params.packageSectionId = this.sectionId;
              }else {
                params.sectionId = this.sectionId;
              }

            }
            if(time > 0){
                api.postFormAPI(url,params).then(res => {
                    console.log(res)
                })
            }

            // console.log(window.cc_js_Player.getPosition())
            
        },
        createPlayer(id) {
            // console.log('jjj',this.videoId)
			this.test = document.getElementById("videoPlayer");
			this.player = window.createCCH5Player({
				vid: id,
				siteid: "3BF7C9738A6F67BC",
				autoStart: true,
				width: "100%",
				height: "100%",
				parentNode: this.test
			});
        },
        setPlayerCallBack() {
			window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded
			window.on_CCH5player_ready = this.onPlayerReady;
			window.on_player_volumechange = this.onPlayerVolumeChange;
		},
		onCCH5PlayerLoaded() {
			window.ccH5PlayerJsLoaded = true;
			this.createPlayer();
		},
		onPlayerReady(obj) {
			console.log('CCH5player_ready', obj)
			window.cc_js_Player.setVolume(0.3);
		},
		onPlayerVolumeChange(volume, vid) {
            console.log('设置音量回调:  ', volume, vid)
        }
    },
	destroyed() {
		this.player && this.player.destroy();
	}

}
</script>
<style lang="">
    .videoHome{
        width:100%;
        height: 100%;
        position:fixed;
        left:0;
        top:0;
        z-index: 9999;
        background: rgba(0,0,0,.6);
    }
    .videoBox{
        width:1200px;
        height: 550px;
        position: fixed;
        left:50%;
        top:50%;
        transform: translate(-50%, -50%);
    }
    .videoTitle{
        width:100%;
        height:40px;
        border-radius: 10px 10px 0 0;
        overflow: hidden;
        background: white;
    }
    .viderName{
        line-height: 40px;
        padding-left: 20px;
        font-size: 20px;
        color:#999;
        float:left;
    }
    .closeVideo{
        width: 40px;
        height: 40px;
        display: table-cell;
        vertical-align: middle;
        float: right;
        line-height: 40px;
    }
    .closeVideo:hover{
        cursor: pointer;
    }
    .closeVideo img{
        width:15px;
        height: 15px;
        display: inline-block;
    }
    #videoPlayer{
        width:100%;
        height: 510px;
    }
</style>



// WEBPACK FOOTER //
// src/components/videoPlayer/viderPlayer.vue